

export default function StatCard(props) {

    return(
        <div className="card">
            <div className="card-body">
                {/* <h5 className="card-title">{props.title}</h5> */}
                {/* <div className="card-text">{props.percent ? props.percent : "N/A"}</div> */}
                <div className="progress" role="progressbar" aria-label="Basic example" aria-valuenow={props.percent} aria-valuemin="0" aria-valuemax="100" style={{height: '25px', fontSize: '0.875rem'}}>
                    <div className="progress-bar" style={{width: props.percent}}>{props.percent ? props.percent : "N/A"}</div>
                </div>
            </div>
        </div>
    )
}